import { render, staticRenderFns } from "./FormationOrders.vue?vue&type=template&id=06e28766&scoped=true"
import script from "./FormationOrders.vue?vue&type=script&lang=js"
export * from "./FormationOrders.vue?vue&type=script&lang=js"
import style0 from "./FormationOrders.vue?vue&type=style&index=0&id=06e28766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e28766",
  null
  
)

export default component.exports